// HM-359..362 cluster 16.2: client API checkout flow.

import { api } from './client.js';

export type CheckoutGuest = {
  id: string;
  firstName: string;
  lastName: string;
  phone: string | null;
  email: string | null;
};

export type ExtraHourLogEntry = {
  id: string;
  hourIndex: number;
  addedAt: string;
  amount: string;
  removed: boolean;
  removedByUserId: string | null;
  removedAt: string | null;
  removedReason: string | null;
  removedNotes: string | null;
};

export type CheckoutSummary = {
  booking: {
    id: string;
    publicCode: string;
    service: 'day_use' | 'overnight';
    startAt: string;
    endAt: string;
    totalAmount: string;
    paidAmount: string;
    extraAmount: string;
    status: string;
  };
  guest: CheckoutGuest | null;
  paymentInitial: { id: string; method: string; amount: string } | null;
  extraHoursLog: ExtraHourLogEntry[];
  pricingRuleId: string | null;
  overrideRole: 'admin_only' | 'admin_reception';
  totals: {
    baseTotal: string;
    extraSum: string;
    /** ONDATA 1: ordini room-service a voucher non pagati (inclusi nel totalDue). */
    rsVoucherSum: string;
    totalDue: string;
    totalPaid: string;
    balanceDue: string;
    /** ONDATA 1: surplus gia' pagato oltre il dovuto (da rimborsare a mano). */
    guestCredit: string;
  };
};

export async function fetchCheckoutSummary(bookingId: string): Promise<CheckoutSummary> {
  return api(`/bookings/${bookingId}/checkout-summary`);
}

export async function removeExtraHour(
  id: string,
  body: { reason: string; notes?: string | null },
): Promise<{ extraHourLogEntry: ExtraHourLogEntry }> {
  return api(`/extra-hours-log/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export async function finalizeCheckout(
  bookingId: string,
  body: { paymentMethod: 'cash' | 'card'; amountReceived?: number },
): Promise<{
  booking: { id: string; status: string };
  /** Importo incassato ORA (0.00 se il soggiorno era gia' saldato). */
  balanceDue: string;
  paymentMethod: string;
  extraSum: string;
  roomServiceSum?: string;
  totalDue: string;
  /** ONDATA 1: surplus da rimborsare a mano (presente solo se > 0). */
  guestCredit?: string;
  /** ONDATA 1: resto contanti (presente se amountReceived inviato). */
  change?: string;
  paymentReference?: string;
  revokedAccessCodes?: number;
  warnings?: Array<{ stage: string; message: string }>;
}> {
  return api(`/bookings/${bookingId}/checkout`, {
    method: 'POST',
    body: JSON.stringify(body),
  });
}
